export default {
    LOAD_BUDGET(state, budget) {
        state.items = budget;
    }
}